import { useConfig } from './useConfig';

interface Environment {
  readonly name: string;
  readonly colorCode: string;
}

const environments: ReadonlyArray<Environment> = [
  {
    name: "local",
    colorCode: "#ba49c4", // violet
  },
  {
    name: "dev",
    colorCode: "#f75959", // red
  },
  {
    name: "test",
    colorCode: "#22b522", // green
  },
  {
    name: "prod",
    colorCode: "#0060df", // blue
  },
];

const getEnvironmentColor = (env: string) => {
  const environment = environments.find((e) => e.name === env);

  return environment?.colorCode || "yellow";
};

export const useEnvironment = () => {
  const { ENVIRONMENT } = useConfig();
  return {
    isLocal: ENVIRONMENT === "local",
    isDev: ENVIRONMENT === "dev",
    isQa: ENVIRONMENT === "test",
    isProd: ENVIRONMENT === "prod",
    name: ENVIRONMENT,
    color: getEnvironmentColor(ENVIRONMENT),
  };
};
